export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sort.vue?vue&type=template&id=15edfa96&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/sort/sort.vue?vue&type=template&id=15edfa96&
// module id = 1193
// module chunks = 0